/* storybook-check-ignore */
import { Listing } from 'declarations/exclusives/listing';
import { Text, Flex } from '@opendoor/bricks/core';

export default function NoPriceInfo({ listing }: { listing: Listing }) {
  return (
    <Flex flexDirection="column">
      <Text fontSize="s0" color="neutrals100" opacity="0.6">
        Exclusive Price
      </Text>
      <Text
        fontSize="s3"
        fontWeight="bold"
        lineHeight="s3"
        pr="0.5rem"
        margin="0"
        backgroundClip="text"
        style={{
          backgroundColor: 'var(--colors-brand50)',
          backgroundImage:
            'linear-gradient(106.38deg, var(--colors-brand50) 33.66%, var(--colors-neutrals100) 115.11%)',
          backgroundSize: '100%',
          backgroundRepeat: 'repeat',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          color: 'transparent',
        }}
      >
        Available soon
      </Text>
      <Text fontSize="s0" lineHeight="s0" pr="0.5rem" margin="0" mb="1.25rem">
        Subscribe to the watchlist to receive email updates when this home is available to tour and
        purchase.
        {listing.exclusive_listing_info.should_obfuscate_address
          ? " The exact location of this Exclusive will be revealed when it's available."
          : ''}
      </Text>
    </Flex>
  );
}
